const WalletModule = () => import(/* webpackChunkName: "wallet-module" */ './views/Module.vue');
const Deposit = () => import(/* webpackChunkName: "wallet-module" */ './views/Deposit.vue');
const Withdrawal = () => import(/* webpackChunkName: "wallet-module" */ './views/Withdrawal.vue');
const Transaction = () => import(/* webpackChunkName: "wallet-module" */ './views/Transaction.vue');
const WalletHistoryDetail = () => import(/* webpackChunkName: "wallet-history-detail" */ './views/WalletHistoryDetail.vue');

const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
      {
        path: 'deposit', 
        name: 'wallet-deposit',
        component: Deposit,
      },
      {
        path: 'withdrawal', 
        name: 'wallet-withdrawal',
        component: Withdrawal,
      },
      {
        path: 'transaction', 
        name: 'wallet-transaction',
        component: Transaction,
      },
      {
        path: 'wallet-history-detail/:type',
        name: 'wallet-history-detail',
        component: WalletHistoryDetail,
      },
    ],
};

export default WalletRoutes;